// Shared consent contract. pulse.joinin.ai reads the same cookies, so the
// names, shapes and lifetimes here are a cross-app contract: change them in
// both places or not at all.

const GA_MEASUREMENT_ID = 'G-N7KYP9JJDN';

const CONSENT_COOKIE = 'joinin_consent';
const CONSENT_MAX_AGE = 15552000; // 180 days
const CONSENT_VERSION = 1;

const FIRST_TOUCH_COOKIE = 'joinin_ft';
const FIRST_TOUCH_MAX_AGE = 7776000; // 90 days
// Landing data held (not a cookie) until analytics consent is known.
const FIRST_TOUCH_PENDING_KEY = 'joinin_ft_pending';

// Shared parent domain. Hosts outside it (localhost, *.web.app previews)
// get host-only cookies so the banner still works there.
const COOKIE_PARENT_DOMAIN = 'joinin.ai';

// analytics_storage defaults to denied here (Google resolves the region from
// the visitor's IP): EEA (EU-27 + IS, LI, NO), UK, Switzerland, Canada.
const DEFAULT_DENIED_REGIONS = [
  'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU',
  'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES',
  'SE', 'IS', 'LI', 'NO', 'GB', 'CH', 'CA',
];

// Event the footer "Cookie settings" link fires to reopen the banner.
const OPEN_EVENT = 'joinin:open-cookie-settings';

module.exports = {
  GA_MEASUREMENT_ID,
  CONSENT_COOKIE,
  CONSENT_MAX_AGE,
  CONSENT_VERSION,
  FIRST_TOUCH_COOKIE,
  FIRST_TOUCH_MAX_AGE,
  FIRST_TOUCH_PENDING_KEY,
  COOKIE_PARENT_DOMAIN,
  DEFAULT_DENIED_REGIONS,
  OPEN_EVENT,
};
